import React from 'react';
import RiskButton from './RiskButton';

function HighRiskButton(props) {
    return (
        <RiskButton
            active={props.active}
            buttonText="High"
            buttonColor="var(--red)"
        />
    );
}

export default HighRiskButton;
